export const addAndRemoveObjectsFromArray = (
  original = [],
  add = [],
  remove = [],
  prop = 'id',
) => {
  const newArray = [
    ...original.filter((obj) => !remove.includes(obj[prop])),
    ...add,
  ];

  return newArray;
};
